import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import { toast } from "react-toastify";
import API from "../../services/api";
const initialState = {
  FetchLocationData: {},
  status: StatusCode.IDLE,
};
const { ADMINFETCHLOCATION, INVITE } = ApiEndPoint;
export const createUserSlice = createSlice({
  name: "createUser/fetch/location",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // case for get location
      .addCase(fetchLocation.pending, (state, action) => {
        // state.status = StatusCode.LOADING;
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.FetchLocationData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchLocation.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      // send email
      .addCase(inviteViaEmail.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(inviteViaEmail.fulfilled, (state, action) => {
        state.status = StatusCode.IDLE;
      })
      .addCase(inviteViaEmail.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const {} = createUserSlice.actions;
export default createUserSlice.reducer;
export const fetchLocation = createAsyncThunk("fetch/location", async () => {
  try {
    const res = await API.get(`${ADMINFETCHLOCATION}`);
    return res.data;
  } catch (error) {
    toast.error(error.data?.message);
  }
});

// create batch kits

export const inviteViaEmail = createAsyncThunk(
  "create/users/invite",
  async (data) => {
    try {
      const res = await API.post(`${INVITE}`, data);
      if (res.status === 200) {
        toast.success(res.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
